exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n:host .group-item {\n  margin-right: 15px;\n}\n\nform {\n  display: inline;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  padding: 0 5px;\n  border-radius: 4px;\n  margin: 2px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: #0080af;\n}\n\nform input[type=submit] {\n  background: none;\n  color: #fff;\n  border: none;\n  padding: 0;\n  font-weight: normal;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n", ""]);

// exports
